var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1258_7053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 11.3333C9.69171 11.3333 11.3333 9.69171 11.3333 7.66667C11.3333 5.64162 9.69171 4 7.66667 4C5.64162 4 4 5.64162 4 7.66667C4 9.69171 5.64162 11.3333 7.66667 11.3333Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3334 11.3333C18.3585 11.3333 20.0001 9.69171 20.0001 7.66667C20.0001 5.64162 18.3585 4 16.3334 4C14.3084 4 12.6667 5.64162 12.6667 7.66667C12.6667 9.69171 14.3084 11.3333 16.3334 11.3333Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 20.0001C9.69171 20.0001 11.3333 18.3585 11.3333 16.3334C11.3333 14.3084 9.69171 12.6667 7.66667 12.6667C5.64162 12.6667 4 14.3084 4 16.3334C4 18.3585 5.64162 20.0001 7.66667 20.0001Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6666 15.6666H16.9999V13.9999C16.9999 13.8231 16.9297 13.6535 16.8047 13.5285C16.6796 13.4035 16.5101 13.3333 16.3333 13.3333C16.1564 13.3333 15.9869 13.4035 15.8618 13.5285C15.7368 13.6535 15.6666 13.8231 15.6666 13.9999V15.6666H13.9999C13.8231 15.6666 13.6535 15.7368 13.5285 15.8618C13.4035 15.9869 13.3333 16.1564 13.3333 16.3333C13.3333 16.5101 13.4035 16.6796 13.5285 16.8047C13.6535 16.9297 13.8231 16.9999 13.9999 16.9999H15.6666V18.6666C15.6666 18.8434 15.7368 19.013 15.8618 19.138C15.9869 19.263 16.1564 19.3333 16.3333 19.3333C16.5101 19.3333 16.6796 19.263 16.8047 19.138C16.9297 19.013 16.9999 18.8434 16.9999 18.6666V16.9999H18.6666C18.8434 16.9999 19.013 16.9297 19.138 16.8047C19.263 16.6796 19.3333 16.5101 19.3333 16.3333C19.3333 16.1564 19.263 15.9869 19.138 15.8618C19.013 15.7368 18.8434 15.6666 18.6666 15.6666Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1258_7053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.d6c6a3d2695013e52ad063fe4144fdb5.svg";
export { ForwardRef as ReactComponent };